import request from '../request'
import type { ApiResponse } from '../types'
import type {
  tradeC2cAdsListParams,
  tradeC2cAdsListResponse,
  tradeC2cAdsListResponseList,
  tradeC2cMyAdsListParams,
  tradeC2cMyAdsListResponse,
  tradeC2cMyAdsListItem,
  tradeC2cAdsDetailParams,
  tradeC2cAdsDetailResponse,
  tradeC2cAdsCreateRequest,
  tradeC2cAdsPauseRequest,
  tradeC2cAdsPublishRequest,
  tradeC2cAdsCancelRequest,
  tradeC2cMyOrderUnreadResponse,
  tradeC2cMyOrderListParams,
  tradeC2cOrderProcessListParams,
  tradeC2cMyOrderListResponse,
  tradeC2cMyOrderListResponseItem,
  tradeC2cOrderDetailParams,
  tradeC2cOrderDetailResponse,
  tradeC2cOrderCreateRequest,
  tradeC2cOrderCreateResponse,
  tradeC2cOrderCancelRequest,
  tradeC2cOrderAgreeRequest,
  tradeC2cOrderPayRequest,
  tradeC2cOrderSendRequest,
  tradeC2cOrderPayCertRequest,
  tradeC2cOrderUnusualRequest,
  tradeC2cOrderReportRequest,
  tradeC2cOrderCommentRequest,
  tradePriceResponse,
  tradeC2cPriceListResponse,
  tradeC2cPriceListItem,
  tradeC2cMyOrderListRequest,
  tradeC2cResponseVersion,
} from './types'
export * from './types'

/**
 * 广告列表
 */
export function tradeC2cAdsListApi(
  params: tradeC2cAdsListParams,
): Promise<ApiResponse<tradeC2cAdsListResponse>> {
  return request.get('/trade/c2c/ads/list', { params })
}

export interface ChatRecommendAdsRequest {
  buy_count: number
  pay_method_id: number[]
}

/** 获取推荐广告 */
export function chatRecommendAdsApi(
  data: ChatRecommendAdsRequest,
): Promise<ApiResponse<tradeC2cAdsListResponse>> {
  return request.get('/trade/c2c/ads/recommend/list', { params: data })
}

export interface tradeC2cOrderFastSellRequest {
  pay_method_id: number
  sell_count: number
}
/**
 * 快速出售
 */
export function tradeC2cOrderFastSellApi(
  data: tradeC2cOrderFastSellRequest,
): Promise<ApiResponse<null>> {
  return request.post('/trade/c2c/order/fast/sell', data)
}

/** 快速出售价格 */
export function tradeC2cOrderFastSellPriceApi(): Promise<
  ApiResponse<{
    price: string
  }>
> {
  return request.get('/trade/c2c/order/fast/sell/price')
}
/** 快速出售汇率（USDT） */
export function tradeC2cOrderFastSellRateApi(): Promise<
  ApiResponse<{
    rate: string
  }>
> {
  return request.get('/trade/c2c/order/fast/sell/rate')
}

export interface tradeC2cOrderFastSellListRequest {
  page: number
  size: number
  start_at?: number
  end_at?: number
}

/** 快速出售列表单项 */
export interface tradeC2cOrderFastSellListItem {
  id: number
  member_id: number
  /** 展示用订单号，如 FS2026… */
  pretty_id: string
  price: string
  total: string
  total_price: string
  status: number
  status_str: string
  remark: string
  created_at: string
  /** 若有则展示「数量 + 币种」，否则前端可兜底 */
  currency?: string
  /** 汇率（USDT） */
  rate: string
  /** 支付方式代码,比如USDT，CNY */
  pay_method_code: string
}

/** 快速出售订单列表接口 data */
export interface tradeC2cOrderFastSellListResponse {
  list: tradeC2cOrderFastSellListItem[]
  total: number
}

/**
 * 快速出售订单列表
 */
export function tradeC2cOrderFastSellListApi(
  data: tradeC2cOrderFastSellListRequest,
): Promise<ApiResponse<tradeC2cOrderFastSellListResponse>> {
  return request.get('/trade/c2c/order/fast/sell/list', { params: data })
}

/**
 * 我的广告列表
 */
export function tradeC2cMyAdsListApi(
  params: tradeC2cMyAdsListParams,
): Promise<ApiResponse<tradeC2cMyAdsListResponse>> {
  return request.get('/trade/c2c/my/ads/list', { params })
}

/**
 * 广告详情
 */
export function tradeC2cAdsDetailApi(
  params: tradeC2cAdsDetailParams,
): Promise<ApiResponse<tradeC2cAdsDetailResponse>> {
  return request.get('/trade/c2c/ads/detail', { params })
}

/**
 * 发布广告
 */
export function tradeC2cAdsCreateApi(data: tradeC2cAdsCreateRequest): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/ads/create', data)
}

/**
 * 暂停广告
 */
export function tradeC2cAdsPauseApi(data: tradeC2cAdsPauseRequest): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/ads/pause', data)
}

/**
 * 重新发布广告
 */
export function tradeC2cAdsPublishApi(data: tradeC2cAdsPublishRequest): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/ads/publish', data)
}

/**
 * 取消广告
 */
export function tradeC2cAdsCancelApi(data: tradeC2cAdsCancelRequest): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/ads/cancel', data)
}

/**
 * 我的订单列表 - 未读
 */
export function tradeC2cMyOrderUnreadApi(): Promise<ApiResponse<tradeC2cMyOrderUnreadResponse>> {
  return request.get('/trade/c2c/my/order/unread')
}

/**
 * 我的订单列表
 */
export function tradeC2cMyOrderListApi(
  data: tradeC2cMyOrderListRequest,
): Promise<ApiResponse<tradeC2cMyOrderListResponse>> {
  return request.post('/trade/c2c/my/order/list', data)
}

/**
 * 进行中的订单列表
 */
export function tradeC2cOrderProcessListApi(
  params: tradeC2cOrderProcessListParams,
): Promise<ApiResponse<tradeC2cMyOrderListResponse>> {
  return request.get('/trade/c2c/order/process/list', { params })
}

/**
 * 订单详情
 */
export function tradeC2cOrderDetailApi(
  params: tradeC2cOrderDetailParams,
): Promise<ApiResponse<tradeC2cOrderDetailResponse>> {
  return request.get('/trade/c2c/order/detail', { params })
}

/**
 * 发起交易
 */
export function tradeC2cOrderCreateApi(
  data: tradeC2cOrderCreateRequest,
): Promise<ApiResponse<tradeC2cOrderCreateResponse>> {
  return request.post('/trade/c2c/order/create', data)
}

/**
 * 取消交易
 */
export function tradeC2cOrderCancelApi(
  data: tradeC2cOrderCancelRequest,
): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/cancel', data)
}

/**
 * 同意交易
 */
export function tradeC2cOrderAgreeApi(
  data: tradeC2cOrderAgreeRequest,
): Promise<ApiResponse<tradeC2cResponseVersion>> {
  return request.post('/trade/c2c/order/agree', data)
}

/**
 * 交易支付法币
 */
export function tradeC2cOrderPayApi(
  data: tradeC2cOrderPayRequest,
): Promise<ApiResponse<tradeC2cResponseVersion>> {
  return request.post('/trade/c2c/order/pay', data)
}

/**
 * 交易放行货币
 */
export function tradeC2cOrderSendApi(
  data: tradeC2cOrderSendRequest,
): Promise<ApiResponse<tradeC2cResponseVersion>> {
  return request.post('/trade/c2c/order/send', data)
}

/**
 * 上传交易凭证
 */
export function tradeC2cOrderPayCertApi(
  data: tradeC2cOrderPayCertRequest,
): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/pay/cert', data)
}

/**
 * 订单报异常
 */
export function tradeC2cOrderUnusualApi(
  data: tradeC2cOrderUnusualRequest,
): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/unusual', data)
}

/**
 * 订单举报
 */
export function tradeC2cOrderReportApi(
  data: tradeC2cOrderReportRequest,
): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/report', data)
}

/**
 * 订单评论
 */
export function tradeC2cOrderCommentApi(
  data: tradeC2cOrderCommentRequest,
): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/comment', data)
}

/**
 * 订单维权
 */
export function tradeC2cOrderRightProtectApi(data: {
  order_id: string
}): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/right/protect', data)
}

/**
 * 订单维权举证
 */
export function tradeC2cOrderRightProtectProofApi(data: {
  order_id: string
  reason: string
  description: string
  picture: number[]
}): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/right/protect/proof', data)
}

/**
 * 取消订单维权
 */
export function tradeC2cOrderRightProtectCancelApi(data: {
  order_id: string
}): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/right/protect/cancel', data)
}

/**
 * 维权申诉
 */
export function tradeC2cOrderRightProtectAppealApi(data: {
  order_id: string
  reason: string
  description: string
  picture: number[]
}): Promise<ApiResponse<any>> {
  return request.post('/trade/c2c/order/right/protect/appeal', data)
}

/** 维权举证文件（列表项内） */
export interface tradeC2cOrderRightProtectProofFile {
  cover_url: string
  created_at: number
  enc_url: string
  file_id: number
  kind: number // kind=0图片 kind=1 视频
  raw_url: string
}

/** 维权订单列表单项（字段以后端为准，前端做可选兼容） */
export interface tradeC2cOrderRightProtectListItem {
  id: number
  pretty_no: string
  order_id: string
  member_right_protect: number
  member_appeal: number
  reason_right_protect: string
  reason_appeal: string
  proof_right_protect?: string[]
  proof_right_protect_detail?: tradeC2cOrderRightProtectProofFile[]
  proof_appeal?: string[]
  proof_appeal_detail?: tradeC2cOrderRightProtectProofFile[]
  description_right_protect: string
  description_appeal: string
  right_protect_count: string
  freeze_id: number
  freeze_count: string
  remark: string
  status: number
  created_at: string
  updated_at: string
}

export interface tradeC2cOrderRightProtectListParams {
  page: number
  size: number
  start_at?: number
  end_at?: number
}

/**
 * 维权订单列表
 */
export function tradeC2cOrderRightProtectListApi(
  params: tradeC2cOrderRightProtectListParams,
): Promise<
  ApiResponse<{
    list: tradeC2cOrderRightProtectListItem[]
    total: number
  }>
> {
  return request.get('/trade/c2c/order/right/protect/list', { params })
}

/**
 * 交易历史记录
 */
export function tradeC2cOrderHistoryApi(): Promise<ApiResponse<any>> {
  return request.get('/trade/c2c/order/history')
}

/**
 * 获取价格
 */
export function tradePriceApi(): Promise<ApiResponse<tradePriceResponse>> {
  return request.get('/trade/price')
}

/**
 * 价格列表
 */
export function tradeC2cPriceListApi(): Promise<ApiResponse<tradeC2cPriceListResponse>> {
  return request.get('/trade/c2c/price/list')
}
